// Placeholder copy for the not-yet-built tenant landing pages (court / creditor / client portal)
// and for the volunteer landing area that keeps the mailed registration flow from dead-ending.
const placeholders = {
  court: "Gericht – Zugangscode eingeben (Platzhalter)",
  creditor: "Gläubigerschutzverband (Platzhalter)",
  portal: "Kund:innen-Portal (Platzhalter)",
  volunteer: {
    title: "Bereich für Ehrenamtliche",
    body: "Ihr Zugang ist aktiv. Der Bereich für Ehrenamtliche wird derzeit umgesetzt. Für die Arbeit mit Ihren zugewiesenen Kundenakte melden Sie sich bitte in der Anwendung der Schuldenberatung Wien an.",
    signedInAs: "Angemeldet als",
  },
};

export default placeholders;
